import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useState, useCallback, useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import useDebounceCallback from './useDebounceCallback.es.js';
import useQueryParams from './useQueryParams.es.js';
import '@babel/runtime/helpers/esm/objectSpread2';
import 'query-string';
import './useConstant.es.js';
import './utils.es.js';
import './encdec.es.js';
import '@babel/runtime/helpers/esm/typeof';
import 'memoize-one';
import './useMemoCompare.es.js';
import 'fast-deep-equal';

function stripQuestionMark(search) {
  if (search.startsWith('?')) {
    return search.slice(1);
  }

  return search;
}

function useRouterDebounceQueryParams(qpEncoder) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var location = useLocation();
  var history = useHistory();

  var _options$delay = options.delay,
      delay = _options$delay === void 0 ? 200 : _options$delay,
      passOptions = _objectWithoutProperties(options, ["delay"]);

  var _useState = useState(location.search),
      _useState2 = _slicedToArray(_useState, 2),
      queryString = _useState2[0],
      setQueryString = _useState2[1];

  var setSearchStr = useCallback(function (nextQueryString) {
    var historyMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'push';

    /*
     * WARNING: do not be tempted to direcly use "location" from outer scope here,
     * since it changes at every render. This may cause an infinite render loop.
     */
    var url = "".concat(history.location.pathname, "?").concat(nextQueryString);
    setQueryString(nextQueryString);
    history[historyMethod](url);
  }, [history]);

  var _useQueryParams = useQueryParams(location.search, setSearchStr, qpEncoder, passOptions),
      _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
      debQueryParams = _useQueryParams2[0],
      setLocalDebQueryParams = _useQueryParams2[1];

  var _useQueryParams3 = useQueryParams(queryString, setQueryString, qpEncoder, passOptions),
      _useQueryParams4 = _slicedToArray(_useQueryParams3, 2),
      queryParams = _useQueryParams4[0],
      setQueryParams = _useQueryParams4[1];

  var prevKey = useRef(location.key);
  useEffect(function () {
    if (prevKey.current !== location.key && stripQuestionMark(queryString) !== stripQuestionMark(location.search)) {
      setQueryString(location.search);
    }

    prevKey.current = location.key;
  }, [location.key, location.search, queryString]);
  var setDebQueryParams = useDebounceCallback(function (nextQueryParams) {
    setLocalDebQueryParams(nextQueryParams);
  }, delay, []);
  var setDebQueryState = useCallback(function (nextQueryParams) {
    setQueryParams(nextQueryParams);
    setDebQueryParams(nextQueryParams);
  }, [setDebQueryParams, setQueryParams]);
  return [queryParams, setLocalDebQueryParams, debQueryParams, setDebQueryState];
}

export default useRouterDebounceQueryParams;
